// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-3d56bf62]{padding:0 0 0 .7em}section[data-v-3d56bf62] label{color:var(--colour-dark-blue);margin:0}.error[data-v-3d56bf62] label{font-weight:400}.error-message[data-v-3d56bf62]{color:var(--colour-red);font-size:var(--small);padding-top:.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
